import React from 'react'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as QuestionMarkIcon } from '@toasttab/shared/src/assets/svg/icon-question-mark.svg'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as CheckMarkIcon } from '@toasttab/shared/src/assets/svg/icon-check-mark.svg'
import Heading from '@toasttab/shared/src/components/molecules/Heading/Heading'
import { FeaturedSnippetProps } from './FeaturedSnippet.d'

const FeaturedSnippetModule = ({
  heading,
  icon,
  wysiwyg
}: FeaturedSnippetProps) => {
  const renderIcon = () => {
    return (
      <div className='mb-4 md:mb-0 md:mr-4'>
        {icon.toLowerCase() === 'questionmark' && <QuestionMarkIcon />}
        {icon.toLowerCase() === 'checkmark' && <CheckMarkIcon />}
      </div>
    )
  }

  return (
    <section className='flex flex-col  md:flex-row mt-7 p-6 bg-otl-tan-dark border-2 border-solid border-otl-gray-light3'>
      {renderIcon()}
      <div>
        <Heading
          heading='h3'
          content={heading}
          classes='mb-6 items-center min-h-[40px] flex'
          color={['text-default']}
          fontWeight='font-semibold'
          fontSize={['text-3xl']}
          textAlign={['text-left']}
          fontFamily='font-calibre'
        />

        <div className='featured-snippet__wysiwyg'>
          {renderRichText(wysiwyg)}
        </div>
      </div>
    </section>
  )
}

export default FeaturedSnippetModule
